<template>
	<div :style="{width:bannerSize[0]+'px',height:bannerSize[1]+'px'}" class="banner">
		<!--banner-->
		<div v-for="(item,index) in imgList" :key="index">
			<transition mode="out-in" :enter-active-class="effect[0]" :leave-active-class="effect[1]">
				<img v-if="show==index+1"
                     class="img"
                     :style="{'animation-duration':`${offer.transition?1:0}s`}" 
                     :src="item" />
			</transition>
		</div>
	</div>
</template>
<script>
export default {
    name: 'cBanner',
    props: {
        offer: {
            //banners
            type: Object,
            default: () => ({})
        },
        bannerSize: {
            type: Array
        }
    },
    data() {
        return {
            effectList: {
                0: ['', ''],
                1: ['fadeIn', 'fadeOut']
            },
            effect: ['fadeIn', 'fadeOut'],
            show: 1, //显示索引
            interval: '' //定时器
        };
    },
    computed: {
        imgList() {
            if (!this.offer.imgList) return [];
            return this.offer.imgList.filter(item => item.imgUrl).map(item => item.imgUrl);
        }
    },
    watch: {
        imgList: {
            handler: function() {
                //第一次加载图片的时候，添加定时器
                clearInterval(this.interval);
                const transition = this.offer.transition ? 1000 : 0;
                this.effect = this.effectList[this.offer.transition];
                this.interval = setInterval(() => {
                    this.show = this.show == this.imgList.length ? 1 : this.show + 1;
                }, this.offer.speed + transition);
            },
            immediate: true
        }
    },
    beforeDestroy() {
        clearInterval(this.interval);
    }
};
</script>

<style lang="scss">
@import '../../style/animate.min.css';
.banner {
    position: relative;
    margin: 0 auto;
    .img {
        position: absolute;
        margin: 0 auto;
        top: 0;
        left: 0;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/commons/cBanner.vue